import { render, staticRenderFns } from "./DashboardRoad.vue?vue&type=template&id=27ddb518&scoped=true&"
import script from "./DashboardRoad.vue?vue&type=script&lang=js&"
export * from "./DashboardRoad.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRoad.vue?vue&type=style&index=0&id=27ddb518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddb518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
